import { Component } from '@theme/component';

const countryLanguages = { IT: 'it', FR: 'fr', DE: 'de', ES: 'es', BR: 'pt-BR', PT: 'pt-PT', GB: 'en', US: 'en' };

class VrLocalization extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.initialize();
  }

  updatedCallback() {
    super.updatedCallback();
    this.initialize();
  }

  initialize() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.addEventListener('change', event => {
      const field = event.target;
      if (!(field instanceof HTMLSelectElement) || !field.form) return;
      if (field.matches('[data-region-country]') && this.dataset.matchCountry === 'true') {
        const language = this.querySelector('[data-region-language]');
        const preferred = countryLanguages[field.value];
        if (language instanceof HTMLSelectElement && preferred) {
          const available = Array.from(language.options).find(option => option.value.toLowerCase() === preferred.toLowerCase());
          if (available) language.value = available.value;
        }
      }
      if (field.matches('[data-region-country], [data-region-language]')) field.form.requestSubmit();
    }, { signal: this.controller.signal });
  }

  disconnectedCallback() {
    this.controller?.abort();
    super.disconnectedCallback();
  }
}

if (!customElements.get('vr-localization')) customElements.define('vr-localization', VrLocalization);
